import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { requestInterface } from 'src/app/util/interfaces/request';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class TaskExpirationService {
	private putTaskExpirationUrl = environment.baseApiUrl + 'request/approvalExpiration/{expirationTime}';
	private getTaskExpirationUrl = environment.baseApiUrl + 'request/approvalExpiration';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getTaskExpiration(): Observable<requestInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<requestInterface[]>(this.getTaskExpirationUrl, { headers: headers });
	}

	updateTaskExpiration(expirationTime: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putTaskExpirationUrl = this.putTaskExpirationUrl.replace('{expirationTime}', expirationTime);
		return this.http.put<JSON>(putTaskExpirationUrl, {}, { headers: headers });
	}
}
